import { Z_INC } from '../constants.js';
/**
 * Position an Object3D at the horizontal center of the node's computed layout.
 */
export function setPositionCenter(obj, nodeWrapper, scale) {
    var _a;
    const w = nodeWrapper.node.getComputedWidth();
    if (isNaN(w)) {
        return;
    }
    obj.setPositionLocal([
        (nodeWrapper.node.getComputedLeft() + 0.5 * nodeWrapper.node.getComputedWidth()) *
            scale[0],
        -nodeWrapper.node.getComputedTop() * scale[1],
        Z_INC + ((_a = nodeWrapper.props.z) !== null && _a !== void 0 ? _a : 0),
    ]);
}
/**
 * Position an Object3D at the left edge of the node's computed layout.
 */
export function setPositionLeft(obj, nodeWrapper, scale) {
    var _a;
    obj.setPositionLocal([
        nodeWrapper.node.getComputedLeft() * scale[0],
        -nodeWrapper.node.getComputedTop() * scale[1],
        Z_INC + ((_a = nodeWrapper.props.z) !== null && _a !== void 0 ? _a : 0),
    ]);
}
/**
 * Position an Object3D at the right edge of the node's computed layout.
 */
export function setPositionRight(obj, nodeWrapper, scale) {
    var _a;
    obj.setPositionLocal([
        (nodeWrapper.node.getComputedLeft() + nodeWrapper.node.getComputedWidth()) *
            scale[0],
        -nodeWrapper.node.getComputedTop() * scale[1],
        Z_INC + ((_a = nodeWrapper.props.z) !== null && _a !== void 0 ? _a : 0),
    ]);
}
